"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRecrutationInfoUrl = '/GetRecrutationInfoUrl';
//# sourceMappingURL=GetRecrutationInfo.js.map